import { HeightUnit } from "@/Common/Utilities/Units/Units";
import { BaseUnitComponent } from "./BaseUnitComponent";

class HeightUnitComponent extends BaseUnitComponent {
    protected get unitLabels(): { [unit: number]: string } {
        return {
            [HeightUnit.Centimeter]: "CentimeterUnitSymbolLabel",
            [HeightUnit.Inch]: "InchUnitSymbolLabel",
            [HeightUnit.Meter]: "MeterUnitSymbolLabel"
        };
    }

    protected get readonlyUnitLabels(): { [unit: number]: string } {
        return {
            [HeightUnit.Centimeter]: this.props.useAbbreviation ? "CentimeterUnitSymbolLabel" : "CentimeterUnitLabel",
            [HeightUnit.Inch]: this.props.useAbbreviation ? "InchUnitSymbolLabel" : "InchUnitLabel",
            [HeightUnit.Meter]: this.props.useAbbreviation ? "MeterUnitSymbolLabel" : "MeterUnitLabel"
        };
    }
}

export { HeightUnitComponent };
